export default {"src":"/_next/static/media/phone-cracked.50fc8207.svg","height":77,"width":66};